module.exports = __webpack_public_path__ + "img/mlh_honor_2.81318aea.png";